import { DocumentsTypes, DocumentsAction, Document } from '../types';

export function getDocumentsList(documents: Document[]): DocumentsAction<{ documents: Document[] }> {
    return {
        type: DocumentsTypes.GET_DOCUMENTS_LIST,
        payload: { documents },
    };
}

export function requestGetDocumentsList() {
    return {
        type: DocumentsTypes.REQUEST_GET_DOCUMENTS_LIST,
    };
}

export function saveDocument(document?: Document): DocumentsAction<{ document?: Document }> {
    return {
        type: DocumentsTypes.SAVE_DOCUMENT,
        payload: { document },
    };
}

export function requestSaveDocument(document: Document): DocumentsAction<{ document: Document }> {
    return {
        type: DocumentsTypes.REQUEST_SAVE_DOCUMENT,
        payload: { document },
    };
}
